export default {
  es: {
    systolic: 'Sistólica',
    diastolic: 'Diastólica',
    create: 'Crear nuevo registro',
    edit: 'Editar registro',
    delete: 'Eliminar registro',
    confirm: 'Confirmar registro',
    textContent:
      'Aquí se muestran los últimos valores de tensión arterial que has registrado:',
    textContentGlucometry:
      'Aquí se muestran los últimos valores de glucometría que has registrado:',
    deleteRecord: '¿Estás seguro de eliminar este registro?',
    recordCreated: 'Un nuevo registro ha sido creado',
    recordUpdated: 'Un registro ha sido actualizado',
    recordDeleted: 'Un registro ha sido eliminado',
    yesterday: 'Ayer',
    date: 'Fecha',
    high: 'Alta',
    low: 'Baja',
    updateMeasureBP: 'Actualiza tu toma de tensión arterial',
    updateMeasureG: 'Actualiza tu toma de glucometría',
    update: 'Actualizar registro',
    recordMeasureBP: 'Registra tu toma de tensión arterial',
    recordMeasureG: 'Registra tu toma de glucometría',
    creation: 'Crear registro',
    moment: 'Momento de la toma',
    select: '-- Selecciona --',
    value: 'Valor',
    lengthError: 'Debe contener valores de dos o tres dígitos'
  },
  en: {
    systolic: 'Systolic',
    diastolic: 'Diastolic',
    create: 'Create new record',
    edit: 'Edit record',
    delete: 'Delete record',
    confirm: 'Confirm record',
    textContent: 'Here are the last blood pressure values ​​you have recorded:',
    textContentGlucometry:
      'Here are the last glucometry values ​​you have recorded:',
    deleteRecord: 'Do you want to delete this record?',
    recordCreated: 'A new record have been created',
    recordUpdated: 'A record have been updated',
    recordDeleted: 'A record have been deleted',
    yesterday: 'Yesterday',
    date: 'Date',
    high: 'High',
    low: 'Low',
    updateMeasureBP: 'Update your blood pressure measurement',
    updateMeasureG: 'Update your glucometry measurement',
    update: 'Update record',
    recordMeasureBP: 'Record your blood pressure measurement',
    recordMeasureG: 'Record your glucometry measurement',
    creation: 'Create record',
    moment: 'Measurement moment',
    select: '-- Select --',
    value: 'Value',
    lengthError: 'It must have two or three digit values'
  }
};
